import React  from 'react'
import ReactQuill, { Quill } from 'react-quill'

import { ReadOnly, ReadOnlyBlock } from "./NoteEditor.blots"

const modules = {
  toolbar: {
    container: "#toolbar",
  }
}


const NoteEditor = ({value, onChange, locked = false}) => {

  if (locked) {
    Quill.register(ReadOnly)
    Quill.register(ReadOnlyBlock)
  }

  return (
    <ReactQuill
      value={value}
      className='editor'
      modules={modules}
      theme='snow'
      onChange={onChange}
      placeholder='Add your note..'
    />
  )
}

export { NoteEditor }